import { StrategicRecommendation } from 'types'

export const FEATURE_LABELS: Record<StrategicRecommendation['feature'], string> = {
  topic: 'Topic',
  captions: 'Captions',
  images: 'Images',
} as const

export const CHANNEL_LABELS: Record<StrategicRecommendation['channel_type'], string> = {
  social: 'Social Media',
  seo: 'SEO',
  email: 'Email',
} as const
